import TIML from '../../../framework/timl.js';
import { ShowPage } from '../crud/shared.js';

class HelpArticlesDetails {
  static timl = `
    table.details-table
      tbody
        tr
          th Category
          td {{ item.category }}
        tr
          th Question
          td {{ item.question }}
        tr
          th Answer
          td {{ item.description }}
        tr
          th Last Updated
          td {{ item.updatedAt }}
  `;
}

export class HelpArticlesShow extends ShowPage {
  static timl = `
    <Breadcrumbs title="Help" href="/help" nameHref="/help/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="" suffixStyle="display:none;" suffixSeparatorStyle="display:none;">
    div#help-articles-details.mt-15 Loading...
  `;

  static mapItemToViewModel(item) {
    return {
      item: {
        category: item.category || '—',
        question: item.question || '—',
        description: item.description || '—',
        updatedAt: Util.formatDate(item.updatedAt || item.createdAt) || '—'
      }
    };
  }

  static javascript() {
    super.javascript();

    API.get(API.resourceUrl('helpArticles', Routing.params.id))
      .then(data => {
        const viewModel = this.mapItemToViewModel(data.data);
        document.querySelector('#name').innerText = viewModel.item.question;
        TIML.renderInto(document.querySelector('#help-articles-details'), HelpArticlesDetails, viewModel);
      });
  }
}
